import { MODULE_ICON_MAP } from "../../../constants/moduleicon";
import { ROUTE_PATHS } from "../../../routes/route-paths";

const APP_BREADCRUMB = {
  [ROUTE_PATHS.CONNECT_REQUESTS]: {
    isRoot: true,
    paths: [{ label: "Connect", icon: MODULE_ICON_MAP.CONNECT }],
    title: "Connect",
  },
  [ROUTE_PATHS.OPPORTUNITY]: {
    isRoot: true,
    paths: [{ label: "Opportunity", icon: MODULE_ICON_MAP.OPPORTUNITY }],
    title: "Opportunity",
  },
  [ROUTE_PATHS.REVIEWS]: {
    isRoot: true,
    paths: [{ label: "Reviews", icon: MODULE_ICON_MAP.REVIEWS }],
    title: "Reviews",
  },
  [ROUTE_PATHS.INITIATIVES]: {
    isRoot: true,
    paths: [{ label: "Initiatives", icon: MODULE_ICON_MAP.INITIATIVES }],
    title: "Initiatives",
  },
  [ROUTE_PATHS.APP_SETTINGS]: {
    isRoot: true,
    paths: [{ label: "App Settings", icon: MODULE_ICON_MAP.APP_SETTINGS }],
    title: "App Settings",
  },
};

export { APP_BREADCRUMB };
